import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {XmlRedResponse} from "../../../../models/api-xml-2/xml-2/xml-2-response.model";


@Component({
  selector: 'app-modal-result-xml-red',
  templateUrl: './modal-result-xml-red.component.html'
})
export class ModalResultXmlRedComponent implements OnInit {


  @Input() public data:XmlRedResponse;

  constructor(public activeModal: NgbActiveModal,) {
  }

  ngOnInit(): void {
  }


  clickButtonSave(){
      this.activeModal.close();
  }






}
